import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";
import { useGetTradeCardByIdQuery } from "../../../redux/tradeCardApi";
import AreaChart from "../dashboard/AreaChart";
import { useGetUserExchnageApiQuery } from "../../../redux/userExchangeApi";
import {
  BinanceType,
  exchangeType,
  orderTypeArr,
  tiggerbinanceTypeArr,
  tiggerbingxTypeArr,
  tradePositionTypeArr,
} from "../../constant/enum";
import { useSetOpenTradeMutation } from "../../../redux/placeOrderApi";
import { toast } from "react-toastify";
import socket from "../../constant/socket";
import { useAuth } from "../../../AuthContext";
import TradeHistory from "./TradeHistory";
import PositionHistory from "./PositionHistory";
import PendingOrder from "./PendingOrder";
import { GetPriceFunCom } from "../../services/Priceget";
import { binanceSocket } from "../../constant/baseUrl";

function Invest() {
  const { id } = useParams();
  const { userId } = useAuth();
  const [setOpenTrade] = useSetOpenTradeMutation();
  const { data } = useGetTradeCardByIdQuery({ id });
  const { data: userApi } = useGetUserExchnageApiQuery();
  // const { data: tradeHistory } = useGetTradeHistoryQuery({ id });
  const [tradeHistory, setTradeHistory] = useState([]);
  const [pendingOrderHistory, setPendingOrderHistory] = useState([]);
  const [price, setPrice] = useState(null);
  const [symbol, setSymbol] = useState("");
  const [exchange, setExchnage] = useState("");
  const [exchangeErr, setExchnageErr] = useState("");
  const [exchnageTypeArr, setExchnageTypeArr] = useState([]);
  const [pairId, setPairId] = useState("");
  const [disable, setDisable] = useState(false);
  const [type, setType] = useState("OPEN");
  const [positionData, setPositionData] = useState([]);
  const [activeTab, setActiveTab] = useState("Position");
  const [firstSymbol, setFirstSymbol] = useState("");
  const [secondSymbol, setSecondSymbol] = useState("");
  const [size, setSize] = useState("");
  const [sizeErr, setSizeErr] = useState("");
  const [currency, setCurency] = useState("");
  const [symbolArray, setSymbolArray] = useState([]);
  const [orderType, setOrderType] = useState("MARKET");
  const [tiggerType, setTiggerType] = useState("TRIGGER_LIMIT");
  const [endPrice, setEndPrice] = useState(0);
  const [endPriceErr, setEndPriceErr] = useState("");
  const [limitPrice, setLimitPrice] = useState(0);
  const [limitPriceErr, setLimitPriceErr] = useState("");
  const [TradeStatusPros, setTradeStatusPros] = useState(false)

  useEffect(() => {
    if (exchange == BinanceType) {
      setTiggerType("STOP");
    } else {
      setTiggerType("TRIGGER_LIMIT");
    }
  }, [exchange, orderType]);

  useEffect(() => {
    if (data && data.length > 0) {
      setSymbol(
        data[0].first_coin_symbol.toLowerCase() +
          data[0].second_coin_symbol.toLowerCase()
      );
      setFirstSymbol(data[0].first_coin_symbol);
      setPairId(data[0].pair_id);
      setCurency(data[0].first_coin_symbol);
      setSecondSymbol(data[0].second_coin_symbol);
      setSymbolArray([
        { key: data[0].first_coin_symbol, value: data[0].first_coin_symbol },
        { key: data[0].second_coin_symbol, value: data[0].second_coin_symbol },
      ]);
    }
  }, [data]);

  useEffect(() => {
    if (userApi && userApi.length > 0) {
      const exchange = userApi.map((list) => list.exchange_type);
      const result = exchangeType.filter((item) =>
        exchange.includes(item.value)
      );
      setExchnageTypeArr(result);
    }
  }, [userApi]);

  useEffect(() => {
    if (!symbol) return;

    let ws;
    let intervalId;
    const isUSDT = secondSymbol === "USDT";

    if (isUSDT) {
      ws = new WebSocket(`${binanceSocket}${symbol.toLowerCase()}@ticker`);

      ws.onopen = () => {
        console.log("WebSocket connected");
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          const price = parseFloat(data.c).toFixed(4);
          document.title = `${price} | ${symbol}`;
          setPrice(price);

          if (limitPrice === 0) {
            setLimitPrice(price);
          }
        } catch (error) {
          console.error("Error parsing WebSocket message:", error);
        }
      };

      ws.onerror = (err) => {
        console.error("WebSocket error:", err);
      };
    } else {
      intervalId = setInterval(() => {
        getPriceData();
      }, 2000);
    }

    return () => {
      if (ws) ws.close();
      if (intervalId) clearInterval(intervalId);
      console.log("Cleaned up WebSocket or Interval");
    };
  }, [symbol, secondSymbol]);

  const getPriceData = async () => {
    const getPrice = await GetPriceFunCom(symbol);
    if (getPrice) {
      setPrice(parseFloat(getPrice.lastPrice)); // 'c' = current price
      document.title = `${getPrice.lastPrice} | ${symbol}`;
      if (limitPrice === 0) {
        setLimitPrice(parseFloat(getPrice.lastPrice).toFixed(4));
      }
    }
    console.log(getPrice, "getPrice");
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    if (name === "exchange") {
      setExchnage(value);
      if (value === "") {
        setExchnageErr("This field is required.");
      } else {
        setExchnageErr("");
      }
    }
    if (name === "size") {
      setSize(value);
      if (value === "") {
        setSizeErr("Please enter valid size.");
      } else if (value <= 0) {
        setSizeErr("Invalid value.");
      } else {
        setSizeErr("");
      }
    }
    if (name === "orderType") {
      setOrderType(value);
    }
    if (name === "limitPrice") {
      setLimitPrice(value);
      if (value === "") {
        setLimitPriceErr("Please enter valid price.");
      } else if (value <= 0) {
        setLimitPriceErr("Invalid value.");
      } else {
        setLimitPriceErr("");
      }
    }
    if (name === "endPrice") {
      setEndPrice(value);
      if (value === "") {
        setEndPriceErr("Please enter valid price.");
      } else if (value <= 0) {
        setEndPriceErr("Invalid value.");
      } else {
        setEndPriceErr("");
      }
    }
  };

  useEffect(() => {
    if (orderType) {
      setLimitPrice(price);
    }
  }, [orderType]);

  const handleSubmit = (e, side, position_side) => {
    e.preventDefault();
    if (exchange === "") {
      setExchnageErr("This filed is required.");
      return;
    }
    if (orderType === "LIMIT") {
      if (limitPrice === "") {
        setLimitPriceErr("Please enter valid price.");
        return;
      }
      if (limitPrice <= 0) {
        setLimitPriceErr("Invalid value.");
        return;
      }
    }
    if (size === "") {
      setSizeErr("This filed is required.");
      return;
    }
    if (size <= 0) {
      setSizeErr("Please enter valid size.");
      return;
    }
    if (currency === firstSymbol) {
      const usdtAmount = parseFloat(price * size).toFixed(6);
      if (usdtAmount < data[0]?.min_usdt_trade) {
        const quantity = parseFloat(data[0]?.min_usdt_trade / price).toFixed(6);
        setSizeErr(
          `Minimum quantity is ${data[0]?.min_usdt_trade} USDT =${quantity} ${firstSymbol}`
        );
        return;
      }
    }
    if (currency !== firstSymbol) {
      const usdtAmount = parseFloat(size).toFixed(data[0]?.accept_decimal);
      if (usdtAmount < data[0]?.min_usdt_trade) {
        const quantity = parseFloat(data[0]?.min_usdt_trade / price).toFixed(
          data[0]?.accept_decimal
        );
        setSizeErr(
          `Minimum quantity is ${data[0]?.min_usdt_trade} USDT =${quantity} ${firstSymbol}`
        );
        return;
      }
    }
    let tirgger_type;
    if (exchange == BinanceType) {
      if (position_side === "LONG") {
        if (endPrice > price) {
          tirgger_type = "STOP";
        } else {
          tirgger_type = "TAKE_PROFIT";
        }
      }
      if (position_side === "SHORT") {
        if (endPrice > price) {
          tirgger_type = "TAKE_PROFIT";
        } else {
          tirgger_type = "STOP";
        }
      }
    }
    const sendData = {
      pair_id: pairId,
      quantity:
        currency === firstSymbol
          ? size
          : parseFloat(
              size /
                (orderType === "LIMIT" || orderType === "TRIGGER"
                  ? tiggerType === "STOP" || tiggerType === "TRIGGER_LIMIT"
                    ? limitPrice
                    : price
                  : price)
            ).toFixed(data[0]?.accept_decimal),
      exchange_type: exchange,
      trade_card_id: id,
      usdt_amount:
        currency === firstSymbol
          ? parseFloat(
              (orderType === "LIMIT" || orderType === "TRIGGER"
                ? tiggerType === "STOP" || tiggerType === "TRIGGER_LIMIT"
                  ? limitPrice
                  : price
                : price) * size
            ).toFixed(data[0]?.accept_decimal)
          : size,
      side: side,
      position_side: position_side,
      type_o_c: type,
      order_type: orderType,
      limit_price: limitPrice,
      stopPrice: endPrice,
      triggerType: exchange == BinanceType ? tirgger_type : tiggerType,
    };
    setDisable(true);
    setTradeStatusPros(true)
    setOpenTrade(sendData).then((result) => {
      if (result.error) {
        setDisable(false);
        setTradeStatusPros(false)
        toast.dismiss();
        toast.error(result.error.data.message);
        return;
      }
      if (result.data.status) {
        toast.dismiss();
        toast.success(result.data.message);
        setDisable(false);
        setSize("");
        setTimeout(() => {
          setTradeStatusPros(false)
        }, 3000);
      } else {
        toast.dismiss();
        toast.error(result.data.message);
        setDisable(false);
        setTradeStatusPros(false)
      }
    });
  };

  useEffect(() => {
    if (id && userId) {
      socket.emit("get-position", { trade_card_id: id, user_id: userId });
      socket.emit("get-trade-history", { trade_card_id: id, user_id: userId });
      socket.emit("get-limit-trade-history", {
        trade_card_id: id,
        user_id: userId,
      });
      socket.on(`recieveposition-${id}`, (data) => {
        if (data.status) {
          setPositionData(data.data);
        }
      });
      socket.on(`recieve-trade-history-${id}`, (data) => {
        if (data.status) {
          setTradeHistory(data.data);
        }
      });
      socket.on(`recieve-limit-trade-history-${id}`, (data) => {
        if (data.status) {
          setPendingOrderHistory(data.data);
        } else {
          setPendingOrderHistory([]);
        }
      });
    }
  }, [userId, id]);

  const handleType = (value) => {
    setType(value);
    setOrderType("MARKET");
    setEndPrice(0);
    setLimitPrice(0);
  };

  const handleCurrency = (value) => {
    setCurency(value);
    setSize("");
  };

  const handleTiggerType = (value) => {
    setTiggerType(value);
  };

  const orderTypeFilter =
    type === "OPEN"
      ? orderTypeArr
      : orderTypeArr.filter((list) => list.value != "TRIGGER");

  return (
    <>
      <Header />
      <div className="in_page">
        <div className="container  ">
          <div className="row">
            {data?.map((list) => {
              return (
                <div className="col-md-6 mb-4">
                  <div className="d_box1">
                    <div className="d_top d-flex  align-items-center">
                      <img
                        src="/assets/img/logo1.png"
                        alt="Logo"
                        className="d_logo"
                      />
                      <div className="ps-3 pe-3">
                        <h4
                          className="mb-0 fw600"
                          title={list?.title?.length > 20 ? list.title : ""}
                        >
                          {list.title
                            ? list.title.length > 20
                              ? list.title.slice(0, 20) + "..."
                              : list.title
                            : ""}
                        </h4>
                        <small
                          title={
                            list?.description?.length > 20
                              ? list.description
                              : ""
                          }
                        >
                          {list.description
                            ? list.description.length > 60
                              ? list.description.slice(0, 60) + "..."
                              : list.description
                            : ""}
                        </small>
                      </div>
                    </div>
                    <div className="d_box2">
                      <div className="p-md-4 p-3 pb-0">
                        <div className="d-flex justify-content-between align-items-center ign mb-3">
                          <div className="">
                            <h4
                              className="mb-1 fw600"
                              title={list?.title?.length > 20 ? list.title : ""}
                            >
                              {list.title
                                ? list.title.length > 20
                                  ? list.title.slice(0, 20) + "..."
                                  : list.title
                                : ""}
                            </h4>
                            <span className="small1">
                              {" "}
                              <span className="d_border me-1">
                                {list.first_coin_symbol}/
                                {list.second_coin_symbol}
                              </span>{" "}
                              {list.total_followers} Followers
                            </span>
                          </div>
                          <div className="d-md-flex w55 justify-content-between align-items-center">
                            <div className="price_d mb-2 justify-content-center mb-md-0">
                              <h4 className="mb-0 fw600">{price}</h4>
                            </div>
                            <div class="">
                              <span class="d_trtr1">
                                <p>Futures</p>
                                <p class="d_trtr3">USDm</p>
                              </span>
                              {/* <span class="d_trtr4">
                            <p>{list.result_time}x</p>
                            <p>Leverage</p>
                          </span> */}
                            </div>
                          </div>
                        </div>

                        <div class="topstrategies_roi_div__dyLhR mb-4 pt-md-3">
                          <div class="toit mb-2">
                            <p className="mb-1"></p>
                            <p className="mb-1">ROI</p>
                            <p className="mb-1"></p>
                          </div>
                          <div class="topstrategies_table__1NGhs">
                            <div class="topstrategies_td__oEDZx">
                              <p class="taa">3M</p>
                              <p>|</p>
                              <p class="tbb tcc">4.43%</p>
                            </div>
                            <div class="topstrategies_td__oEDZx">
                              <p class="taa">6M</p>
                              <p>|</p>
                              <p class="tbb tcc">104.18%</p>
                            </div>
                            <div class="topstrategies_td__oEDZx">
                              <p class="taa">1Y</p>
                              <p>|</p>
                              <p class="tbb tcc">240.16%</p>
                            </div>
                            <div class="topstrategies_td__oEDZx">
                              <p class="taa">2Y</p>
                              <p>|</p>
                              <p class="tbb tcc">963.77%</p>
                            </div>
                            <div class="topstrategies_td__oEDZx">
                              <p class="taa">3Y</p>
                              <p>|</p>
                              <p class="tbb tcc">31.51K%</p>
                            </div>
                            <div class="topstrategies_td__oEDZx">
                              <p class="taa">4Y</p>
                              <p>|</p>
                              <p class="tbb tcc">374.05K%</p>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-between pt-2">
                          <div className="">
                            <h4 className="mb-1 fw600 color2">+240.16%</h4>
                            <span className="small1"> Annualized ROI</span>
                          </div>
                          <div className="">
                            <h4 className="mb-1 fw600 ">248.45K</h4>
                            <span className="small1"> AUM(USDT)</span>
                          </div>
                        </div>
                      </div>
                      <AreaChart graphData={list.graph} />
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="col-md-6 mb-4">
              <div className="box2 p-3 p-md-4 h100">
                <div className="disclaimer">
                  <p> ⚠️ Disclaimer</p>
                  <p>
                    Before trading, ensure the following settings are correct on
                    your API-bound account:
                  </p>
                  <p>
                    <b>Margin Type:</b> Use the correct margin mode (e.g.,
                    Cross) to avoid unintended leverage or liquidation.
                  </p>
                  <p>
                    <b>Position Mode:</b> Enable Hedge Mode if you plan to hold
                    both LONG and SHORT positions simultaneously.
                  </p>
                  <p>
                    <b>Multi-Asset Mode:</b> Confirm if Multi-Asset Mode is
                    active, as it affects margin calculations and PnL across
                    assets.
                  </p>
                </div>
                {/* <div className="pair-price mb-4  position-relative">
                <i class="bi bi-currency-dollar dollar_icon"></i>
                <p className="mb-2">Price</p>
                <h4 className="mb-0">{price}</h4>
              </div> */}
                <h5 className="">Open Trade</h5>
                <div class="buy_sell d-flex mb-3">
                  <button
                    className={`buy_tab ${type === "OPEN" ? "active" : ""}`}
                    onClick={() => {
                      handleType("OPEN");
                    }}
                  >
                    Open
                  </button>
                  <button
                    className={`sell_tab ${type === "CLOSED" ? "active" : ""}`}
                    onClick={() => {
                      handleType("CLOSED");
                    }}
                  >
                    Close
                  </button>
                </div>
                <form>
                  <div className="trade">
                    <div className="row">
                      <div className="col-md-6">
                        <div>
                          <label className="form-label">Select Type*</label>
                          <select
                            className="form-control"
                            value={orderType}
                            onChange={handleChange}
                            name="orderType"
                          >
                            {orderTypeFilter.map((list) => {
                              return (
                                <option value={list.value}>{list.key}</option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div>
                          <label className="form-label">Select Exchange*</label>
                          <select
                            className="form-control"
                            value={exchange}
                            onChange={handleChange}
                            name="exchange"
                          >
                            <option value="">Select</option>
                            {exchnageTypeArr.map((list) => {
                              return (
                                <option value={list.value}>{list.key}</option>
                              );
                            })}
                          </select>
                          <span className="text-danger">{exchangeErr}</span>
                        </div>
                      </div>
                      {orderType === "LIMIT" && (
                        <div className="col-md-6 mt-2">
                          <label className="form-label">USDT Price</label>
                          <input
                            className="form-control"
                            value={limitPrice}
                            name="limitPrice"
                            onChange={handleChange}
                            onInput={(event) => {
                              let value = event.target.value;
                              // Remove invalid characters (allow digits and dot)
                              value = value.replace(/[^0-9.]/g, "");
                              // Allow only one dot
                              const firstDotIndex = value.indexOf(".");
                              if (firstDotIndex !== -1) {
                                // Remove any additional dots
                                value =
                                  value.substring(0, firstDotIndex + 1) +
                                  value
                                    .substring(firstDotIndex + 1)
                                    .replace(/\./g, "");
                              }
                              // data
                              // Limit to 2 decimal places
                              const [integerPart, decimalPart] =
                                value.split(".");
                              if (decimalPart && decimalPart.length > 4) {
                                value = `${integerPart}.${decimalPart.slice(
                                  0,
                                  4
                                )}`;
                              }
                              event.target.value = value;
                            }}
                          />
                          <span className="text-danger">{limitPriceErr}</span>
                        </div>
                      )}
                      {orderType === "TRIGGER" && (
                        <>
                          <div className="col-md-6 mt-2">
                            <label className="form-label">
                              Stop Price (USDT)
                            </label>
                            <input
                              className="form-control"
                              value={endPrice}
                              name="endPrice"
                              onChange={handleChange}
                              onInput={(event) => {
                                let value = event.target.value;
                                // Remove invalid characters (allow digits and dot)
                                value = value.replace(/[^0-9.]/g, "");
                                // Allow only one dot
                                const firstDotIndex = value.indexOf(".");
                                if (firstDotIndex !== -1) {
                                  // Remove any additional dots
                                  value =
                                    value.substring(0, firstDotIndex + 1) +
                                    value
                                      .substring(firstDotIndex + 1)
                                      .replace(/\./g, "");
                                }
                                // data
                                // Limit to 2 decimal places
                                const [integerPart, decimalPart] =
                                  value.split(".");
                                if (decimalPart && decimalPart.length > 4) {
                                  value = `${integerPart}.${decimalPart.slice(
                                    0,
                                    4
                                  )}`;
                                }
                                event.target.value = value;
                              }}
                            />
                            <span className="text-danger">{endPriceErr}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <label className="form-label">Price (USDT)</label>
                            <div class="input-group">
                              <button
                                class="btn btn-outline-secondary dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                {exchange == BinanceType
                                  ? tiggerbinanceTypeArr.filter(
                                      (list) => list.value == tiggerType
                                    )[0]?.key
                                  : tiggerbingxTypeArr.filter(
                                      (list) => list.value == tiggerType
                                    )[0]?.key}
                              </button>
                              <ul class="dropdown-menu in-drop">
                                {(exchange == BinanceType
                                  ? tiggerbinanceTypeArr
                                  : tiggerbingxTypeArr
                                )?.map((list) => {
                                  return (
                                    <li>
                                      <button
                                        class="dropdown-item"
                                        type="button"
                                        onClick={() => {
                                          handleTiggerType(list.value);
                                        }}
                                      >
                                        {list.key}
                                        {list.value == tiggerType ? (
                                          <i class="bi bi-check"></i>
                                        ) : (
                                          ""
                                        )}
                                      </button>
                                    </li>
                                  );
                                })}
                              </ul>
                              <input
                                type="text"
                                class="form-control drop-inpu"
                                onChange={handleChange}
                                name="limitPrice"
                                disabled={
                                  tiggerType === "TRIGGER_MARKET" ||
                                  tiggerType === "STOP_MARKET"
                                }
                                value={
                                  tiggerType === "TRIGGER_MARKET" ||
                                  tiggerType === "STOP_MARKET"
                                    ? "Market Price"
                                    : limitPrice
                                }
                                onInput={(event) => {
                                  let value = event.target.value;
                                  // Remove invalid characters (allow digits and dot)
                                  value = value.replace(/[^0-9.]/g, "");
                                  // Allow only one dot
                                  const firstDotIndex = value.indexOf(".");
                                  if (firstDotIndex !== -1) {
                                    // Remove any additional dots
                                    value =
                                      value.substring(0, firstDotIndex + 1) +
                                      value
                                        .substring(firstDotIndex + 1)
                                        .replace(/\./g, "");
                                  }
                                  // data
                                  // Limit to 2 decimal places
                                  const [integerPart, decimalPart] =
                                    value.split(".");
                                  if (decimalPart && decimalPart.length > 4) {
                                    value = `${integerPart}.${decimalPart.slice(
                                      0,
                                      4
                                    )}`;
                                  }
                                  event.target.value = value;
                                }}
                              />
                            </div>
                            <span className="text-danger">{limitPriceErr}</span>
                          </div>
                        </>
                      )}
                      <div className="col-md-6 mt-2">
                        <label className="form-label">Size</label>
                        <div class="input-group">
                          <button
                            class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {currency}
                          </button>
                          <ul class="dropdown-menu in-drop">
                            {symbolArray?.map((list) => {
                              return (
                                <li>
                                  <button
                                    class="dropdown-item"
                                    type="button"
                                    onClick={() => {
                                      handleCurrency(list.value);
                                    }}
                                  >
                                    {list.key}
                                    {list.value == currency ? (
                                      <i class="bi bi-check"></i>
                                    ) : (
                                      ""
                                    )}
                                  </button>
                                </li>
                              );
                            })}
                          </ul>
                          <input
                            type="text"
                            class="form-control drop-inpu"
                            onChange={handleChange}
                            name="size"
                            value={size}
                            onInput={(event) => {
                              let value = event.target.value;
                              // Remove invalid characters (allow digits and dot)
                              value = value.replace(/[^0-9.]/g, "");
                              // Allow only one dot
                              const firstDotIndex = value.indexOf(".");
                              if (firstDotIndex !== -1) {
                                // Remove any additional dots
                                value =
                                  value.substring(0, firstDotIndex + 1) +
                                  value
                                    .substring(firstDotIndex + 1)
                                    .replace(/\./g, "");
                              }
                              // data
                              // Limit to 2 decimal places
                              const [integerPart, decimalPart] =
                                value.split(".");
                              if (
                                decimalPart &&
                                decimalPart.length > data[0]?.accept_decimal
                              ) {
                                value = `${integerPart}.${decimalPart.slice(
                                  0,
                                  data[0]?.accept_decimal
                                )}`;
                              }
                              event.target.value = value;
                            }}
                          />
                        </div>
                        <span className="text-danger">{sizeErr}</span>
                      </div>
                    </div>

                    <div className="mt-4 row">
                      <div className="col-6">
                        <button
                          className={`btn buy_btn w100`}
                          type="button"
                          disabled={disable}
                          onClick={(e) => {
                            handleSubmit(
                              e,
                              "BUY",
                              type === "OPEN" ? "LONG" : "SHORT"
                            );
                          }}
                        >
                          {type === "OPEN" ? "Open Long" : "Close Short"}
                        </button>
                      </div>
                      <div className="col-6">
                        <button
                          className={`btn sell_btn w100`}
                          type="button"
                          disabled={disable}
                          onClick={(e) => {
                            handleSubmit(
                              e,
                              "SELL",
                              type === "OPEN" ? "SHORT" : "LONG"
                            );
                          }}
                        >
                          {type === "OPEN" ? "Open Short" : "Close Long"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div className="mb-4 line_tab d-flex">
              {tradePositionTypeArr?.map((list) => {
                return (
                  <button
                    key={list.key}
                    className={`b-tab ${
                      activeTab === list.value ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveTab(list.value);
                    }}
                  >
                    {list.value}
                    {list.key === "PendingOrder"
                      ? `(${pendingOrderHistory?.length})`
                      : ""}
                  </button>
                );
              })}
            </div>
            {activeTab === "Position" && (
              <PositionHistory positionHistory={positionData} />
            )}
            {activeTab === "Trade" && (
              <TradeHistory tradeHistory={tradeHistory} />
            )}
            {activeTab === "PendingOrder" && (
              <PendingOrder pendingOrderHistory={pendingOrderHistory} TradeStatusPros={TradeStatusPros}/>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Invest;
